import React from "react";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";

/**
 * StepperNavButton
 * @param {string} side - "left" vagy "right"
 * @param {function} onClick - kattintás esemény
 * @param {string} [label] - opcionális felirat
 * @param {boolean} [disabled] - letiltott állapot
 * @param {string} [className] - további osztályok
 * @param {React.ReactNode} [children] - opcionális tartalom
 */
const StepperNavButton = ({ side = "right", onClick, label, disabled = false, className = "", children, ...rest }) => {
	const isLeft = side === "left";
	return (
		<button
			type="button"
			className={`btn btn-primary btn-lg stepper-nav-btn position-fixed ${isLeft ? "stepper-left" : "stepper-right"} ${className}`}
			style={{
				bottom: 24,
				left: isLeft ? 24 : "auto",
				right: isLeft ? "auto" : 24,
				zIndex: 1050,
				borderRadius: 0,
				minWidth: 56,
				minHeight: 56,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
				opacity: disabled ? 0.6 : 1,
				pointerEvents: disabled ? "none" : "auto",
			}}
			onClick={onClick}
			disabled={disabled}
			{...rest}
		>
			{isLeft && <IconArrowLeft size={28} style={{ marginRight: label ? 8 : 0 }} />}
			{label}
			{children}
			{!isLeft && <IconArrowRight size={28} style={{ marginLeft: label ? 8 : 0 }} />}
		</button>
	);
};

export default StepperNavButton;
